import { render, staticRenderFns } from "./OtherActivities.vue?vue&type=template&id=9a42e162&scoped=true"
import script from "./OtherActivities.vue?vue&type=script&lang=js"
export * from "./OtherActivities.vue?vue&type=script&lang=js"
import style0 from "./OtherActivities.vue?vue&type=style&index=0&id=9a42e162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a42e162",
  null
  
)

export default component.exports